import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { handleSchemaFailure } from "api/utils";
import { getIdToken } from "domains/authentication/selectors";
import { getSiteLanguage } from "domains/language/selectors";
import type { RootState } from "types";

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/v1`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const idToken = getIdToken(state);
      const siteLanguage = getSiteLanguage(state);

      headers.set("accept-language", siteLanguage);
      headers.set("x-api-key", import.meta.env.VITE_API_KEY);
      if (idToken) headers.set("x-authorization", `Bearer ${idToken}`);

      return headers;
    },
  }),
  onSchemaFailure: handleSchemaFailure,
  tagTypes: ["CustomMaps", "CallToAction"],
  endpoints: () => ({}),
});
